/**
 * Created by kierangrosvenor on 25/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let AccountApi = {
  resetWeek1() {
    return axios.get(config.apiUrl + 'account/reset')
  },
  changePassword(old_password, new_password) {
    return axios.post(config.apiUrl + 'account/changePassword/', {
      new_password: new_password,
      old_password: old_password
    })
  },

  getAccount() {
    return axios.get(config.apiUrl + 'account/')
  },
  /**
   *
   * @param model
   * @returns {AxiosPromise}
   */
  putAccount(model) {
    return axios.put(config.apiUrl + 'account/', model)
  },
  putUserGoals(model) {
    return axios.put(config.apiUrl + 'user/goals/', model)
  },
  getUserConditions() {
    return axios.get(config.apiUrl + 'user/conditions/')
  },
  putUserConditions(model) {
    return axios.put(config.apiUrl + 'user/conditions/', model)
  },
  putUserLocation(model) {
    return axios.put(config.apiUrl + 'user/location/', model)
  },
  putUserPersonalization(model) {
    return axios.put(config.apiUrl + 'user/personalization/', model)
  },
  getUserPersonalization() {
    return axios.get(config.apiUrl + 'user/personalization/')
  },
  sendAccountVerification() {
    return axios.get(config.apiUrl + 'account/sendEmailVerification');
  },
  updateAccountEmail(email) {
    return axios.get(config.apiUrl + 'account/sendEmailUpdateRequest', {
      params: {
        email: email
      }
    });
  },
  verifyAccountWithEmailToken(token) {
    return axios.get(config.apiUrl + 'account/verifyEmailToken', {
      params: {
        token: token
      }
    })
  },
  getMarketingPreferences() {
    return axios.get(config.apiUrl + 'account/marketingPreferences');
  },
  updateMarketingPreferences(model) {
    return axios.post(config.apiUrl + 'account/marketingPreferences', model)
  },
  updateDisplayName(model) {
    return axios.put(config.apiUrl + 'account/display-name/', model)
  },
  createPassword(model) {
    return axios.post(config.apiUrl + 'account/store-password/', model)
  }
};

export default AccountApi;




// WEBPACK FOOTER //
// ./src/api/Account/index.js